import { useEffect, useRef, useState } from "react";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element || !("IntersectionObserver" in window)) {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { rootMargin: "-60px" });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} ${className}`} style={{ "--reveal-delay": `${delay}s`, "--reveal-y": `${y}px` }}>{children}</div>;
};

export const Overline = ({ children }) => (
  <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-brand-blue">
    {children}
  </p>
);
